/**
 * Carousel Autoplay – injected by Sidekick
 * Section: template--25532662448443__carousel_dQHBLL
 * Interval: 4s
 */
(function () {
  var SECTION_ID = 'template--25532662448443__carousel_dQHBLL';
  var INTERVAL_SECONDS = 4;

  function initAutoplay() {
    var section = document.getElementById(SECTION_ID);
    if (!section) return;

    var slideshow = section.querySelector('slideshow-component');
    if (!slideshow) return;

    // Set the autoplay attribute (in seconds) so the built-in play() method uses it
    slideshow.setAttribute('autoplay', String(INTERVAL_SECONDS));

    // Add a slow, smooth CSS scroll transition override for this specific slideshow
    var style = document.createElement('style');
    style.textContent =
      '#' + SECTION_ID + ' slideshow-component [ref~="scroller"] {' +
      '  scroll-behavior: smooth;' +
      '}';
    document.head.appendChild(style);

    // Start autoplay using the theme's built-in play() method.
    // The Slideshow class already handles hover-pause via mouseenter/mouseleave.
    if (typeof slideshow.play === 'function') {
      slideshow.play(INTERVAL_SECONDS * 1000);
    }
  }

  // Wait for the slideshow-component custom element to be defined
  if (typeof customElements !== 'undefined' && typeof customElements.whenDefined === 'function') {
    customElements.whenDefined('slideshow-component').then(function () {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAutoplay);
      } else {
        initAutoplay();
      }
    });
  } else {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAutoplay);
    } else {
      initAutoplay();
    }
  }
})();
